import { checkClient, checkGet, checkPost } from './checkClient';

export interface FavoritePlant {
  id: string;
  name: string;
}

export async function listFavoritePlants(): Promise<FavoritePlant[]> {
  const res = await checkGet<{ plant_ids?: string[]; favorites?: FavoritePlant[] }>('/plants/favorites');
  if (Array.isArray(res.favorites)) return res.favorites;
  return (res.plant_ids ?? []).map((id) => ({ id, name: '' }));
}

export async function listFavoritePlantIds(): Promise<string[]> {
  const plants = await listFavoritePlants();
  return plants.map((plant) => plant.id);
}

export async function addFavoritePlant(plantId: string): Promise<void> {
  await checkPost(`/plants/${plantId}/favorite`);
}

export async function removeFavoritePlant(plantId: string): Promise<void> {
  await checkClient.delete(`/plants/${plantId}/favorite`);
}

export async function addFavoritePlantsBatch(plantIds: string[]): Promise<{ plant_ids: string[]; count: number }> {
  return checkPost<{ plant_ids: string[]; count: number }>('/plants/favorites/batch', { plant_ids: plantIds });
}
